import { render } from "./EditAttachment.vue?vue&type=template&id=4737b680"
import script from "./EditAttachment.vue?vue&type=script&lang=js"
export * from "./EditAttachment.vue?vue&type=script&lang=js"

import "./EditAttachment.vue?vue&type=style&index=0&id=4737b680&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__